<div class="ui-g">
  <div class="ui-g-12 text-right">
    <button
      pButton
      type="button"
      class="k-generic-btn"
      icon="fa fa-plus"
      iconPos="left"
      label="{{ 'report.createNewReport' | translate }}"
      (click)="openModal()">
    </button>
  </div>
  <div class="ui-g-12">
    <app-kontable
      #table
      title="{{ 'report.title' | translate }}"
      [columns]="[
        'id',
        'code',
        'description',
        'query_count',
        {field: 'report_state', title: 'report.reportState', bodyTemplate: reportStateTemplate, filterType: selectFilter, filterOptions: {values: reportStates}},
        {field: 'ts_ins', title: 'common.date_start', bodyTemplate: dateTimeTemplate, filterType: dateFilter},
        {field: 'ts_upd', title: 'common.date_end', bodyTemplate: dateTimeTemplate, filterType: dateFilter}
      ]"
      [titles]="[
        'common.id',
        'common.code',
        'common.description',
        'customerSetBuilder.recordCount'
      ]"
      [paginationType]="paginationType"
      [showInfoButton]="false"
      [showRecoverButton]="false"
      [showGlobalFilter]="false"
      [showEditButton]="false"
      [showDeleteButton]="false"
      (onDetails)="showProcessingDetail($event.error)"
      [showReport]="false"
      [service]="reportService"
      [additionalRowCommands]="customButton">
      <ng-template #customButton data-testid="customButton" let-row>
        <p-button
          icon="fa fas fa-download"
          styleClass="ui-button-info"
          *ngIf="row.report_state === 'P'"
          (onClick)="downloadReport(row.id, row.code)"
          pTooltip="{{ 'report.downloadReport' | translate }}">
        </p-button>
      </ng-template>
      <ng-template #reportStateTemplate data-testid="reportStateTemplate" let-row>
        <span *ngIf="row.report_state === '0'">
          {{'report.generated' | translate}}
        </span>
        <span *ngIf="row.report_state === 'E'">
          {{'report.onError' | translate}}
        </span>
        <span *ngIf="row.report_state === 'P'">
          {{'report.downloadReady' | translate}}
        </span>
        <span *ngIf="row.report_state === 'A'">
          {{'report.onExecution' | translate}}
        </span>
    </ng-template>
    <ng-template #dateTimeTemplate data-testid="dateTimeTemplate" let-row let-value="value">
      {{value | date: 'dd/MM/yyyy hh:mm'}}
    </ng-template>
    </app-kontable>
  </div>
</div>

<p-dialog
  *ngIf="showModal"
  header="{{ 'report.createNewReport' | translate }}"
  [(visible)]="showModal"
  [modal]="true"
  [width]="700"
  [draggable]="false"
  [resizable]="false">
  <app-loyalty-report-form (onCloseModal)="closeModal()" (onSaveReport)="onSaveReport()"></app-loyalty-report-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-report-list/loyalty-report-list.component.html